/**
 * Cross-domain redirect components used when the current build doesn't own a
 * given route.
 *
 * In "marketing" mode: any attempted app path → sends the user to the app
 *   subdomain, preserving path + query so deep links keep working.
 *
 * In "app" mode: attempted marketing paths → sends the user to the marketing
 *   site.
 *
 * In "all" mode (dev / single-deployment) these components are never used —
 * routes render normally.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { APP_URL, MARKETING_URL } from '@/lib/siteMode';

function RedirectExternal({ base }) {
  const { pathname, search, hash } = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(search);
    if (params.has('xdr')) {
      // Already bounced across domains once — neither build owns this path.
      // Land on the local homepage instead of ping-ponging forever.
      window.location.replace('/');
      return;
    }
    if (!base) return;
    params.set('xdr', '1');
    window.location.replace(`${base}${pathname}?${params.toString()}${hash}`);
  }, [base, pathname, search, hash]);
  return (
    <div className="min-h-screen flex items-center justify-center text-slate-500 text-sm">
      Redirecting…
    </div>
  );
}

export function RedirectToApp() {
  return <RedirectExternal base={APP_URL} />;
}

export function RedirectToMarketing() {
  return <RedirectExternal base={MARKETING_URL} />;
}
